import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';

import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as XLSX from 'xlsx'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-importovertime',
  templateUrl: './importovertime.component.html',
  styleUrls: ['./importovertime.component.css']
})
export class ImportovertimeComponent implements OnInit {

  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) { }

    excelColl:any=[];

    ngOnInit() {
    }
    onFileChange(event: any) {
      /* wire up file reader */
      const target: DataTransfer = <DataTransfer>(event.target);
      if (target.files.length !== 1) {
        throw new Error('Cannot use multiple files');
      }
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(target.files[0]);
      reader.onload = (e: any) => {
        /* create workbook */
        const binarystr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
    
        /* selected the first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
    
        /* save data */
        const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
        console.log(data); // Data will be logged in array format containing objects
       this.excelColl=data;
   
      };
    }
  
  
  
    fnSaveBtnClick(){
  for(let row of this.excelColl){
    console.log(row)
    this.fnInsertExcelImport(row)
  }
  }
  fnInsertExcelImport(row){
    var data={
      staffcode:row.staffcode,
      empcode:row.empname,
      trxdate:row.trxdate,
      othours:row.othrs,
      companyid:this.loginService.fnGetCompanyId(),
      modifiedby:this.loginService.fnGetModUserId(),     
      }
      this.appService.fnInsertOvertimeImport(data).subscribe((res)=>{
        if (res.json().status === 200) {
         console.log(res.json().result);
    
        }},
        (err) => {
          this.toastr.error('Error', err);
        });
    }
    public decline() {
      this.activeModal.close(false);
    }
    
    }
    